<avatar stil="liten" [medlem]="medlem()" skjulTooltip="true"/>
<div class="navn-og-rolle">
  <div class="navn e2e_medlem_navn" data-testid="navn">{{ medlem().navn }}</div>
  <div class="rolle">
    {{ aktivRolleTittel() }}
    @if (!medlem().harTilgang) {
      ({{ 'tilgang stengt'|translate }})
    }
  </div>
  <!-- dytt ut eventuelt ekstrainnhold -->
  <div class="ekstra-innhold">
    <ng-content/>
  </div>
</div>
